const metAmorc = [
  { value: 1, label: 'Indicação de amigo ou familiar' },
  { value: 2, label: 'Literatura da mesma' },
  { value: 3, label: 'Facebook' },
  { value: 4, label: 'Portal da AMORC' },
  { value: 5, label: 'Vídeos da AMORC/Canal Rosacruz' },
  { value: 6, label: 'Rádio' },
  { value: 7, label: 'Matéria em Jornal ou Revista' },
  { value: 8, label: 'Revista “O Rosacruz”' },
  { value: 9, label: 'Twitter' },
  { value: 10, label: 'Outras Redes Sociais' },
  { value: 11, label: 'Câmara externa' },
  { value: 12, label: 'Organismo Afiliado' },
  { value: 13, label: 'Domínio da Vida' },
  { value: 14, label: 'Cursos/Palestras' },
  { value: 15, label: 'Meditação aberta' },
  { value: 16, label: 'Pesquisa na internet' },
  { value: 18, label: 'Instagram' },
  { value: 17, label: 'Outro:' },
];

export default metAmorc;
